import React, { useEffect, useMemo, useState } from "react";
import SideMenu from "../dashboard/sideMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  Form,
  Row,
  Col,
  Button,
  Select,
  Collapse,
  Checkbox,
  message,
  Card,
  Typography,
  Space,
} from "antd";
import {
  makeStyles,
  TablePagination,
  TextareaAutosize,
} from "@material-ui/core";
import OutlinedInput from "@mui/material/OutlinedInput";
import MaterialTable, { MTableToolbar } from "material-table";
import { tableIcons } from "../../tableIcons";
import config from "../../config";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useCountry } from "../../provider/courtryProvider";
import { useNavigate } from "react-router-dom";

const { Panel } = Collapse;

const useStyles = makeStyles((theme) => ({
  selectStyle: {
    "& legend": {
      display: "none",
    },
    "& fieldset": {
      top: "0 !important",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
  discountStyle: {
    "& fieldset": {
      borderRight: "0",
      borderRadius: "4px 0 0 4px !important",
    },
    "& legend": {
      display: "none",
    },
  },
  discountTypeStyle: {
    "& fieldset": {
      borderLeft: "0",
      borderRadius: "0 4px 4px 0 !important",
    },
    "& legend": {
      display: "none",
    },
  },
}));

function PatchedPagination(props) {
  const {
    ActionsComponent,
    onChangePage,
    onChangeRowsPerPage,
    ...tablePaginationProps
  } = props;
  return (
    <TablePagination
      {...tablePaginationProps}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
}

export default function CreateSubcription(props) {
  const classes = useStyles();
  const location = useLocation();
  const mode = location?.state?.mode || "create";
  const handleChange = () => {};
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [products, setProducts] = useState([]);
  const locationState = location.state;
  const initialValues = mode === "edit" ? locationState.data : {};
  const tableRef = React.useRef();
  const [category, setCategory] = useState("");
  const country = useCountry();
  const selectedRows = useMemo(
    () => (mode === "edit" ? locationState.data.subscriptionProducts : {}),
    [mode, locationState.data]
  );
  const [productChosen, setProductChosen] = useState([]);
  const selectedRowRef = React.useRef(mode === "edit" ? selectedRows : []);
  const filterProducts = products.filter((product) => {
    return product.category === category;
  });

  const tableData = useMemo(() => {
    const filteredProducts = category === "" ? products : filterProducts;
    return mode === "edit"
      ? filteredProducts.map((product) => {
          if (selectedRows?.includes(product.productId)) {
            return {
              ...product,
              tableData: { checked: true },
            };
          }
          return product;
        })
      : filteredProducts;
  }, [products, selectedRows, mode, category, filterProducts]);

  const getCategoryInProducts = () => {
    const category = products.map((product) => product.category);
    return [...new Set(category)];
  };

  const onFinish = async (values) => {
    let subscriptionDuration = "";
    if (
      values.subscriptionDuration.includes("weekly") &&
      values.subscriptionDuration.includes("monthly")
    ) {
      subscriptionDuration = "both";
    } else if (values.subscriptionDuration.includes("weekly")) {
      subscriptionDuration = "weekly";
    } else if (values.subscriptionDuration.includes("monthly")) {
      subscriptionDuration = "monthly";
    }
    const getRemovedProducts = () => {
      const removedProducts = [];
      selectedRows.forEach((productId) => {
        if (!selectedRowRef.current.includes(productId)) {
          removedProducts.push(productId);
        }
      });
      return removedProducts;
    };
    const payload = {
      shopId: shopDetails.shopId,
      subscriptionName: values.subscriptionName,
      subscriptionDuration: subscriptionDuration,
      termsAndCondition: values.termsAndCondition,
      mealPrice: values.mealPrice,
      sessions: values.sessions,
      subscriptionProducts: selectedRowRef.current,
      ...(mode === "edit" && {
        removedSubscriptionProducts: getRemovedProducts(),
      }),
      ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
        parentShopId: shopDetails.ownerShopId,
      }),
      includeWeekends: values.includeWeekends,
    };
    form.resetFields();
    var res = await fetch(
      `${config.newApiGateway}/subscription/manageSubscription`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          actionType: mode,
          ...(mode === "edit" && { subscriptionId: initialValues.billId }),
          ...payload,
          ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
            parentShopId: shopDetails.ownerShopId,
          }),
        }),
      }
    );
    res = await res.json();
    setLoading(false);
    if (res.code === "ERROR") {
      return message.error(res.message);
    }
    if (res.code === "SUCCESS") {
      message.success(res.message);
      navigate({
        pathname: `/dashboard/subscription`,
      });
      form.resetFields();
    }
  };

  const handleSelect = (rows) => {
    setProductChosen(rows);
    const productIds = rows.map((row) => row.productId);
    selectedRowRef.current = productIds;
  };

  const handleSave = () => {
    if (selectedRowRef.current?.length < 1) {
      return alert("Please select atleast one item");
    }
    //setLoading(true);
    form.submit();
  };

  useEffect(() => {
    const getProductDetails = async (shopId) => {
      await Promise.all([
        fetch(
          `${config.newApiGateway}/products/dashboard-products-allproducts`,
          {
            method: "POST",
            body: JSON.stringify({
              userId: shopId,
              type: "getProductDetails",
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          }
        ),
      ])
        .then(([res]) => Promise.all([res.json()]))
        .then(async ([data]) => {
          if (data.limitExceeds && data.status) {
            try {
              var productData = await fetch(data.products);
              productData = await productData.json();
              let sortedArr = productData.sort((a, b) => {
                if (a.productName === b.productName) return 0;
                if (a.productName > b.productName) return 1;
                return -1;
              });
              setProducts(sortedArr);
              return;
            } catch (err) {
              alert("Failed to fetch product details. Please try again");
              return;
            }
          }
          var sortedArr = data.products.sort((a, b) => {
            if (a.productName === b.productName) return 0;
            if (a.productName > b.productName) return 1;
            return -1;
          });
          setProducts(sortedArr);
        })
        .catch((err) => {
          console.error("Err", err);
        });
    };
    if (shopDetails.shopId) {
      getProductDetails(shopDetails.shopId);
    }
    // return () => {
    //   selectedRowRef([]);
    // }
  }, [shopDetails.shopId]);
  return (
    <>
      <div>
        <Card
          style={{
            marginBottom: 20,
          }}
        >
          <Space
            style={{
              justifyContent: "space-between",
              width: "100%",
            }}
            align="center"
            direction="horizontal"
          >
            <Typography.Title
              style={{
                marginBottom: "0",
              }}
              level={5}
            >
              {mode === "edit" ? "Edit" : "Create"} Subscription Plan
            </Typography.Title>
            <Button type="primary" onClick={handleSave} loading={isLoading}>
              Save
            </Button>
          </Space>
        </Card>
        <div>
          <Collapse
            style={{
              border: "0",
            }}
            defaultActiveKey={["1"]}
            onChange={handleChange}
          >
            <Panel header="Subscription Details" key="1">
              <Form
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                form={form}
                onFinish={onFinish}
                initialValues={{
                  ...initialValues,
                  subscriptionDuration:
                    initialValues.subscriptionDuration === "both"
                      ? ["weekly", "monthly"]
                      : initialValues.subscriptionDuration,
                }}
              >
                <Row gutter={40}>
                  <Col span={12}>
                    <Row>
                      <Col span={24}>
                        <Form.Item
                          label="Subscription Name"
                          name="subscriptionName"
                          rules={[
                            {
                              required: true,
                              message: "Please input your Subscription Name!",
                            },
                          ]}
                        >
                          <OutlinedInput
                            placeholder="Add a subscription name"
                            style={{
                              width: "100%",
                            }}
                            className={classes.selectStyle}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          label="Meal Type"
                          name="sessions"
                          rules={[
                            {
                              required: true,
                              message: "Please input your Select Meals!",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            style={{
                              width: "100%",
                              borderRadius: "4px",
                            }}
                            size="large"
                          >
                            <Select.Option value={"breakFast"}>
                              Break Fast
                            </Select.Option>
                            <Select.Option value={"lunch"}>Lunch</Select.Option>
                            <Select.Option value={"dinner"}>
                              Dinner
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          label="Meal Price(Per Meal)"
                          name="mealPrice"
                          rules={[
                            {
                              required: true,
                              message: "Please input your Select Meals!",
                            },
                          ]}
                        >
                          <OutlinedInput
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            placeholder="Add a subscription price"
                            style={{
                              width: "100%",
                            }}
                            className={classes.selectStyle}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name={"includeWeekends"}
                          valuePropName="checked"
                          style={{
                            marginTop: "-15px",
                          }}
                        >
                          <Checkbox>Include Weekends</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Subscription Duration"
                      name="subscriptionDuration"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Subscription Duration!",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        style={{
                          width: "100%",
                          borderRadius: "4px",
                        }}
                        placeholder="Select Duration"
                        size="large"
                      >
                        <Select.Option value={"monthly"}>Monthly</Select.Option>
                        <Select.Option value={"weekly"}>Weekly</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Terms & Conditions"
                      name={"termsAndCondition"}
                    >
                      <TextareaAutosize
                        rows={6}
                        placeholder="Add your corresponding terms and conditions for the given plan"
                        style={{
                          width: "100%",
                          borderRadius: "4px",
                          padding: "8px",
                          height: "200px",
                          borderColor: "#E0E0E0",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <div>
                <Typography.Title level={5}>Product Chosen</Typography.Title>
                {productChosen.map((product) => {
                  return (
                    <div key={product.productId}>
                      {product.productName}{" "}
                      {(product.size || product.unitOfMeasurment) && (
                        <span>
                          - ({product.size} {product.unitOfMeasurment}){" "}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </Panel>
            <MaterialTable
              title="Items"
              style={{
                border: 0,
                boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",
              }}
              columns={[
                {
                  title: "Item Name",
                  field: "productName",
                  cellStyle: { width: "20% !important" },
                  render: (rowData) => (
                    <span>
                      {rowData.productName} - {rowData.size}{" "}
                      {rowData?.unitOfMeasurment}
                    </span>
                  ),
                },
                {
                  title: "Category",
                  field: "category",
                  cellStyle: { width: "20% !important" },
                },
                {
                  title: "Brand",
                  field: "productBrand",
                  type: "numeric",
                  cellStyle: { width: "20% !important" },
                },
                {
                  title: `Price (${country.CurrencySymbol})`,
                  field: "productPrice",
                  cellStyle: { width: "20% !important" },
                },
                {
                  title: "In Stock",
                  field: "inventoryQty",
                  cellStyle: { width: "20% !important" },
                },
              ]}
              data={tableData}
              options={{
                selection: true,
                selectionProps: (rowData) => ({
                  disabled: rowData.count === 0,
                  value: rowData,
                }),
              }}
              ref={tableRef}
              onSelectionChange={handleSelect}
              icons={tableIcons}
              components={{
                Pagination: PatchedPagination,
                Toolbar: (props) => (
                  <div>
                    <MTableToolbar {...props} />
                    <div className="customToolBar">
                      <div className="categoryDropdown">
                        <select
                          onChange={(e) => setCategory(e.target.value)}
                          value={category}
                          disabled={
                            getCategoryInProducts()?.length > 0 ? false : true
                          }
                        >
                          <option value="">Choose a Category</option>
                          {getCategoryInProducts()?.map((data) => (
                            <option value={data} key={data}>
                              {data}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                ),
              }}
            />
          </Collapse>
        </div>
      </div>
    </>
  );
}
